module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/workspace-footer/equal-housing-opportunity.png?b3aaebdcc17807a5f929b74c3300a611";